// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"b8617659","311":"9988ce43","487":"630dad4a","915":"d04b1cb2"}[chunkId] + ".chunk.css";
};